import React, { useState } from "react";
import OrderDetails from "./OrderDetails";
import "./orderpage.css";
import OngoingOrders from "./OnGoingOrders";
import ComplaintHandling from "./complaint/ComplaintHandling";

function OrderPageIntegration() {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const handleOrderSelect = (order) => {
    setSelectedOrder(order);
  };
  return (
    <div
      style={{
        display: "flex",
        height: "calc(100% - 100px)",
        overflow: "hidden",
      }}
    >
      <div className="onGoingOrders">
        <OngoingOrders handleOrderSelect={handleOrderSelect} />
      </div>
      <div className="orderDetails-complaint-handleing">
        <div className="orderDetails">
          <OrderDetails selectedOrder={selectedOrder} />
        </div>
        <div className="complaintHandeling">
          <ComplaintHandling />
        </div>
      </div>
    </div>
  );
}

export default OrderPageIntegration;
